import { OpenAPI, ContactsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const updateContactInfo = ContactsService.updateContactsContactsUpdatePut

export const getContactInfo = ContactsService.getContactsContactsGetGet